import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LockKey, EnvelopeSimple, ArrowRight } from "@phosphor-icons/react";

export default function MobileLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const result = await login(email, password);
    setSubmitting(false);
    if (result.success) {
      navigate("/m/catalog", { replace: true });
    } else {
      setError(result.error || "Login failed");
    }
  };

  return (
    <div className="mobile-app min-h-screen flex flex-col bg-[#1E3A8A]" data-testid="mobile-login-screen">
      <div className="flex-1 flex flex-col justify-end px-8 pb-14 pt-24 relative overflow-hidden">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/5" />
        <div className="absolute top-24 -left-10 w-40 h-40 rounded-full bg-[#9A3412]/20" />
        <div className="relative z-10">
          <div className="w-14 h-14 rounded-[18px] bg-white/10 border border-white/20 flex items-center justify-center mb-6">
            <span className="font-display text-2xl text-white">BH</span>
          </div>
          <h1 className="font-display text-4xl text-white leading-tight mb-2">Better Home<br />Quotations</h1>
          <p className="text-white/60 text-base">Quote your customers, anywhere.</p>
        </div>
      </div>

      <div className="bg-[#FAFAF9] rounded-t-[32px] px-7 pt-9 pb-10 safe-bottom min-h-[46vh]">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label className="text-xs font-semibold tracking-wide text-[#78716C] uppercase">Email</Label>
            <div className="relative mt-2">
              <EnvelopeSimple size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#78716C]" />
              <Input
                type="email"
                required
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                data-testid="mobile-login-email-input"
                className="h-14 pl-11 rounded-[16px] border-[#E7E5E4] bg-white text-base focus-visible:ring-[#1E3A8A]"
              />
            </div>
          </div>
          <div>
            <Label className="text-xs font-semibold tracking-wide text-[#78716C] uppercase">Password</Label>
            <div className="relative mt-2">
              <LockKey size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#78716C]" />
              <Input
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="mobile-login-password-input"
                className="h-14 pl-11 rounded-[16px] border-[#E7E5E4] bg-white text-base focus-visible:ring-[#1E3A8A]"
              />
            </div>
          </div>

          {error && (
            <p className="text-sm text-[#9A3412] font-medium" data-testid="mobile-login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="mobile-login-submit"
            className="press-scale w-full h-14 rounded-[16px] bg-[#1E3A8A] text-white font-semibold text-base flex items-center justify-center gap-2 shadow-[0_8px_24px_-8px_rgba(30,58,138,0.6)] transition-colors duration-200 hover:bg-[#182f6e] disabled:opacity-60"
          >
            {submitting ? "Signing in..." : "Sign In"}
            {!submitting && <ArrowRight size={18} />}
          </button>
        </form>
      </div>
    </div>
  );
}
